import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { DocumentationType } from "../../../app/settings/calc-plan-editor/model/block";
declare var $: any;

@Component({
    selector: 'app-help-popup',
    templateUrl: './help-popup.component.html',
    styleUrls: ['./help-popup.component.scss'],
    standalone: false
})
export class HelpPopupComponent implements AfterViewInit {
  @Input() description: DocumentationType;
  @ViewChild('helpPopup') helpPopupRef: ElementRef;

  constructor() { }

  ngAfterViewInit() {
    $(this.helpPopupRef.nativeElement).popup({
      popup: ".help-doc",
      inline: true,
      position: "bottom right"
    });
  }
}
